import { render, staticRenderFns } from "./alunos.vue?vue&type=template&id=13be24e8"
import script from "./alunos.vue?vue&type=script&lang=js"
export * from "./alunos.vue?vue&type=script&lang=js"
import style0 from "./alunos.vue?vue&type=style&index=0&id=13be24e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports